import React from 'react';
import "./styles.css";
import CustomModal, { CustomModalContent, CustomModalFooter, ModalPrimaryButton } from '../..';
import { useRoute, useBCMSModal } from "@bcm-dev/bcms-vite";

/**
 * @function UnchangedCardOnFileV2Modal
 * @return {React.Component}
 * @exported true
 * @description The modal that shows when a card on file in unchanged.
 */

export default function UnchangedCardOnFileV2Modal(props){
  const navigate = useRoute();
  const { close } = useBCMSModal();

  const onOKClick = evt => {
    close("UnchangedCardOnFileV2Modal");

    if(props.data) {
      if(props.data.onOKClick) {
        props.data.onOKClick();
      } else {
        navigate("/home/cardonfile/cardonfile");
      }
    }
  }
  

  return(
    <CustomModal className="unchanged-card-on-file-modal" id="UnchangedCardOnFileV2Modal">
      <CustomModalContent>
          <p className="text-center">Your Card on File list remains unchanged.
           The list is maintained for your information purpose only. 
           Contact the merchant or service provider if you want to update your card information on their file.</p>
      </CustomModalContent>
      <CustomModalFooter className="button-container">
          <ModalPrimaryButton text="OK" onClick={ onOKClick } />
      </CustomModalFooter>
    </CustomModal>
  );
}